<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  column: {
    type: String,
    default: ''
  }
})

const valueColumn = computed(() => {
  return props.data[props.column]
})

</script>

<template>
  <span>{{ $h.formatCurrency(parseFloat(valueColumn), 2) }}</span>
</template>

<style scoped>

</style>
